import { toast } from "react-toastify";
import { privateAxios, publicAxios } from "../../../config/apiConfig";
import { isBuyNowCheckoutActive, restoreBuyNowCartSnapshot } from "../Cart/Action";
import { CREATE_ORDER_FAILURE, CREATE_ORDER_REQUEST, CREATE_ORDER_SUCCESS, GET_ORDER_BY_ID_FAILURE, GET_ORDER_BY_ID_REQUEST, GET_ORDER_BY_ID_SUCCESS, GET_ORDER_HISTORY_FAILURE, GET_ORDER_HISTORY_REQUEST, GET_ORDER_HISTORY_SUCCESS, CANCELED_ORDER_REQUEST, CANCELED_ORDER_SUCCESS, CANCELED_ORDER_FAILURE, RETURN_ORDER_REQUEST, RETURN_ORDER_SUCCESS, RETURN_ORDER_FAILURE, GET_ORDER_BY_ORDER_ID_REQUEST, GET_ORDER_BY_ORDER_ID_SUCCESS, GET_ORDER_BY_ORDER_ID_FAILURE } from "./ActionType"

export const createOrder = (addressId, selectedCurrency, selectedCurrencyRate, navigate, cart) => async (dispatch) => {
    dispatch({ type: CREATE_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.post(
            `user/order/address/${addressId}/${selectedCurrency}/${selectedCurrencyRate}`
        );

        if (data && Array.isArray(data)) {
            dispatch({ type: CREATE_ORDER_SUCCESS, payload: data });

            if (isBuyNowCheckoutActive()) {
                await dispatch(restoreBuyNowCartSnapshot());
            }

            // 👉 payment page पर पहला order भेज सकते हो
            const firstOrder = data[0];
            navigate(`/payment/${firstOrder.orderId}`, { state: { cart } });

            // 👉 अब custom sizes को backend में भेजो
            const savedSizes = JSON.parse(localStorage.getItem("customSizes")) || {};

            for (const order of data) {
                for (const item of order.orderItems || []) {
                    const productId = item?.product?.id;
                    const isSize = item?.size === "Custom Tailor";
                    const size = savedSizes[productId];

                    if (size && isSize) {
                        const formattedData = {
                            ...size, // productId, unit, aur size details
                        };

                        await publicAxios.post(`custom_size/${order.id}`, formattedData);
                    }
                }
            }

            // LocalStorage साफ़ कर दो
            localStorage.removeItem("customSizes");
        }
    } catch (error) {
        dispatch({ type: CREATE_ORDER_FAILURE, payload: error.message });
    }
}

export const getOrderById = (orderId) => async (dispatch) => {
    dispatch({ type: GET_ORDER_BY_ID_REQUEST })
    try {
        const { data } = await privateAxios.get(`user/order/${orderId}`);
        dispatch({ type: GET_ORDER_BY_ID_SUCCESS, payload: data })

    } catch (error) {
        dispatch({ type: GET_ORDER_BY_ID_FAILURE, payload: error.message })
    }
}

export const getOrderByOrderId = (orderId) => async (dispatch) => {
    dispatch({ type: GET_ORDER_BY_ORDER_ID_REQUEST })
    try {
        const { data } = await privateAxios.get(`user/order/orderId/${orderId}`);
        dispatch({ type: GET_ORDER_BY_ORDER_ID_SUCCESS, payload: data })

    } catch (error) {
        dispatch({ type: GET_ORDER_BY_ORDER_ID_FAILURE, payload: error.message })
    }
}

export const getUserOrders = () => async (dispatch) => {
    dispatch({ type: GET_ORDER_HISTORY_REQUEST })
    try {
        const { data } = await privateAxios.get(`user/order/user`);
        dispatch({ type: GET_ORDER_HISTORY_SUCCESS, payload: data })

    } catch (error) {
        dispatch({ type: GET_ORDER_HISTORY_FAILURE, payload: error.message })
    }
}

export const cancelOrder = (orderId, region) => async (dispatch) => {
    dispatch({ type: CANCELED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`user/order/${orderId}/cancel`, { region });
        if (data.status === "SUCCESS") {
            dispatch({ type: CANCELED_ORDER_SUCCESS, payload: data })
            dispatch(getOrderById(orderId))
            toast.success("Order Successfully Cancelled !!")
        }
    } catch (error) {
        dispatch({ type: CANCELED_ORDER_FAILURE, payload: error.message })
    }
}

export const returnOrder = (orderId, formData, handleCancle) => async (dispatch) => {
    dispatch({ type: RETURN_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`user/order/${orderId}/return`, formData);
        if (data.status === "SUCCESS") {
            dispatch({ type: RETURN_ORDER_SUCCESS, payload: data })
            dispatch(getOrderById(orderId))
            handleCancle();
        }
    } catch (error) {
        dispatch({ type: RETURN_ORDER_FAILURE, payload: error.message })
    }
}

